import React, {useEffect} from 'react';
import ButtonSecondary from "../../components/ButtonSecondary";

export default function Share({ breeds, petTypes, dietaryGoals }) {
  useEffect(() => {
    window.scroll(0,0);
  }, []);

  return (
  <main className="thank-you posr h80vh df aic jcc">
    <div className="tac">
      <h1 className="fz40 lh1.1111 fw600 mb30">
        Thank You.
      </h1>
      <p className="mb40 lh1.5 fz16">
        Your review has been accepted for moderation.
      </p>
      <ButtonSecondary
        className={"button-secondary--thk w250 m-auto c-red"}
        href={'https://www.thehonestkitchen.com/'}
      >
        Continue Shopping
      </ButtonSecondary>
    </div>
  </main>
  );
}
